import React, { useState, useEffect, useContext } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { ConfirmationDialog } from '../ConfirmationDialog';
import { withRouter } from 'react-router-dom';
import { AgGrid } from '../AgGrid';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { getOrdersColumnDefinitions } from '../../helpers';
import { AppContext } from '../../AppContext';

// SERVICES
import { getInspectorOrders } from '../../services';

const styles = theme => ({});

export const FieldRepOrdersGrid = withRouter(
  withStyles(styles)(props => {
    const {
      state: { roles },
      dispatch,
    } = useContext(AppContext);

    const { showCanceledOrdersOnly } = props;
    const columnDefinitions = getOrdersColumnDefinitions('qa', 'fieldrep');
    const [gridData, setGridData] = useState(null);
    const [showGrid, setShowGrid] = useState(true);

    const gridOptions = {};

    const getInspectorOrdersAsync = async () => {
      try {
        const orders = await getInspectorOrders();
        setGridData(orders);
      } catch (error) {
        console.log(error);
        dispatch({
          type: 'SET_SNACKBAR',
          snackbar: {
            isOpen: true,
            message: 'Error retrieving orders',
            variant: 'error',
          },
        });
      }
    };

    useEffect(() => {
      getInspectorOrdersAsync();
    }, []);

    return (
      <div className={classnames('flex-1', 'card', 'border-left-green', 'col-center-center')}>
        <AgGrid
          gridData={gridData}
          columnDefs={columnDefinitions}
          handleCellClick={evt => props.history.push(`/orders/review/${evt.data.orderTicket}`)}
          redirectOnClick={true}
          editOnClick={false}
          gridOptions={gridOptions}
        />
      </div>
    );
  }),
);

FieldRepOrdersGrid.propTypes = {
  showCanceledOrdersOnly: PropTypes.bool,
};
